<template>
  <div class="homeBg">
    <div class="navigationFrame">
      <div class="fontFrame">
        <div class="imgFrame">
          <img src="../assets/logo.png" class="p-imgStyle" />
        </div>
        <div class="fontContent">
          <div class="fontName">
            <span>{{ corporateName }}</span>
          </div>
          <div class="fontEnglish">
            <span>{{ corporateEnglish }}</span>
          </div>
        </div>
      </div>
      <div class="p-flex">
        <!-- 循环 -->
        <div v-for="(item, index) in array" :key="index" class="loopFrame" @click="navigationFunc(index)">
          <span>{{ item.name }}</span>
        </div>
      </div>
      <!-- <div>
                <el-button icon="el-icon-my-menu" class="buttonBg"></el-button>
       </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      corporateName: "山哩数智科技有限公司官网",
      corporateEnglish: "SHANLI HOLDING TECHNOLOGY CO.LTD",
      array: [
        { name: "首页" }, { name: "集团介绍" }, { name: "农特供应" }, { name: "新闻集" },{ name: "E法通APP" }, { name: "联系我们" }
      ]
    }
  },
  methods: {
    navigationFunc(index) {
      if (index == 0 && this.$route.fullPath !== "/homePage") {
        this.$router.push('/homePage')
      } else if (index == 1 && this.$route.fullPath !== "/group") {
        this.$router.push('/group')
      } else if (index == 2 && this.$route.fullPath !== "/specialSupplyPc") {
        this.$router.push('/specialSupplyPc')
      } else if (index == 3 && this.$route.fullPath !== "/news") {
        this.$router.push('/news')
      } else if (index == 4 && this.$route.fullPath !== "/appIntroduce") {
        this.$router.push('/appIntroduce')
      } else if (index == 5 && this.$route.fullPath !== "/contactWe") {
        this.$router.push('/contactWe')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.homeBg {
  width: 100%;
  background-color: #7B0000;
  display: flex;
  justify-content: center;
  align-items: center;
  // 固定头部
  position: fixed;
  z-index: 999;
}

.navigationFrame {
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.imgFrame {
  height: auto;
  margin-top: 0.5rem;
  width: 80px;
}

.fontFrame {
  padding: 1rem;
  display: flex;
  color: #fff;
  align-items: center;
  letter-spacing: 0.05rem;
  line-height: 2.5rem;
}

.fontContent {
  margin-top: 0.5rem;
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.fontName {
  font-size: 2rem;
  letter-spacing: 0.5rem;
}

.fontEnglish {
  font-size: 1.5rem;
  margin-top: 0.01rem;
}

// 循环模块
.loopFrame {
  color: #fff;
  padding: 0 1.5rem;
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    padding: 2rem 1.5rem;
    background-color: black;
    opacity: 0.8;
    cursor: pointer;
    border-radius: 10px;
  }
}

// 自定义按钮
/deep/ .el-icon-my-menu {
  background: url('../assets/menu4.png') no-repeat center;
  font-size: 3rem;
  background-size: cover;
}

/deep/ .el-icon-my-menu:before {
  content: "代替";
  font-size: 0.1rem;
  visibility: hidden;
}

/deep/ .buttonBg {
  border: none;
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/assembly/homeTop.vue